
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M272.812 505.026l152.164-152.362c9.282-9.296 9.282-24.372 0-33.668-9.286-9.298-24.34-9.298-33.624 0L279.775 430.718V23.807C279.774 10.66 269.129 0 256 0c-13.129 0-23.775 10.66-23.775 23.807v406.911L120.65 319c-9.286-9.298-24.34-9.298-33.624 0-4.643 4.649-6.964 10.741-6.964 16.834s2.321 12.186 6.964 16.834l152.161 152.358c9.287 9.298 24.338 9.298 33.625 0z"}})])
          )
        }
      }
    